import {Dispatch} from 'redux';
import {ErrorDto} from '../../../models/dtos/error.dto';
import {TokenDto} from '../../../models/dtos/token.dto';
import {ApiEvent} from "../../../models/enums/apiEvent";
import {LoginRequest} from '../../../models/requests/login.request';
import {Errors} from '../../../utilities/errors';
import {Helpers} from "../../../utilities/helpers";
import {SessionStorage} from "../../../utilities/sessionStorage";
import {apiEventRequest} from "../../eventService/apiEvent/repository";
import {getMeRequest} from "../../userService/getMe/repository";
import {LOGIN_FAIL, LOGIN_RESET, LOGIN_START, LOGIN_SUCCESS} from './constants';
import {loginRequest} from "./repository";
import {LoginFailAction, LoginResetAction, LoginStartAction, LoginSuccessAction} from './types';

const loginStartAction = (): LoginStartAction => {
  return {
    type: LOGIN_START,
  };
};
const loginSuccessAction = (payload: TokenDto): LoginSuccessAction => {
  return {
    type: LOGIN_SUCCESS,
    payload: payload,
  };
};
const loginFailAction = (error: ErrorDto): LoginFailAction => {
  return {
    type: LOGIN_FAIL,
    error: error,
  };
};
const loginResetAction = (): LoginResetAction => {
  return {
    type: LOGIN_RESET,
  };
};

export const login = (request: LoginRequest) => async (dispatch: Dispatch) => {
  try {
    dispatch(loginStartAction());
    if (!request.token) {
      dispatch(loginFailAction(Errors.ErrorInvalidToken));
    } else {
      const response = await loginRequest(request);
      SessionStorage.set(SessionStorage.token, response.token);
      const me = await getMeRequest(dispatch);
      apiEventRequest({
        ...Helpers.getApiEventCoreData(me),
        event: me.termsAcceptanceDate ? ApiEvent.USER_LOGIN : ApiEvent.NEW_USER,
      }).catch();
      dispatch(loginSuccessAction(response));
    }
  } catch (error) {
    dispatch(loginFailAction(Errors.getErrorDtoFromApiError(error)));
  }
};

export const loginReset = () => (dispatch: Dispatch) => {
  dispatch(loginResetAction());
};
